interface BouwjaarOptionsProps {
    id: string;
    displayName: string;
}

const currentYear = new Date().getFullYear();

/**
 * reverse array order
 * map numbers to key value pairs
 * @param arr
 */
const formatBouwjaarOptions = (arr: number[]): BouwjaarOptionsProps[] => {
    const reversedArray = [...arr].reverse();
    return reversedArray.map((year) => ({
        id: year.toString(),
        displayName: year.toString()
    }));
};

const getRange = (start: number, end: number): number[] => {
    const arrayLength = end - start + 1;
    return arrayLength ? [...Array(arrayLength).keys()].map((i) => start + i) : [];
};

const getMinOptions = (maxValue: number | number[] | null): BouwjaarOptionsProps[] => {
    const correctMaxValue = (Array.isArray(maxValue) ? maxValue[0] : maxValue) || currentYear;
    const rangeEnd = Math.min(currentYear, correctMaxValue);
    return formatBouwjaarOptions(getRange(1900, rangeEnd));
};

const getMaxOptions = (minValue: number | number[] | null): BouwjaarOptionsProps[] => {
    const correctMinValue = (Array.isArray(minValue) ? minValue[0] : minValue) || 0;
    const rangeStart = Math.max(1900, correctMinValue);
    return formatBouwjaarOptions(getRange(rangeStart, currentYear));
};

export { formatBouwjaarOptions, getMinOptions, getMaxOptions, getRange };
